import React from 'react';
import {  BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
// import JuryPolicy from './components/JuryPolicy';
// import WinnersPage from './components/WinnersPage';
// import OrganizerPage from './components/OrganizerPage';
// import JuryByYear from './components/JuryByYear';
// import TermsPage from './components/TermsPage';
// import NominationsPage from './components/NominationsPage';

import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <Header /> 
      <Routes>
        <Route path="/" element={<Hero />} />
        {/* <Route path="/jury" element={<JuryPolicy />} />
        <Route path="/winners" element={<WinnersPage />} />
        <Route path="/organizer" element={<OrganizerPage />} />
        <Route path="/jurylist" element={<JuryByYear />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/nominations" element={<NominationsPage />} /> */}
        
      </Routes>
      <Footer /> 
    </Router>
  );
}

export default App;